import * as React from 'react'
import './page.less'
import {NavLink} from 'react-router-dom'
import {Button} from 'telstra-ui/components/button/Button'

// tslint:disable: no-var-requires
const errorScreen = require('../../../../images/icons/Error_Screen.gif')
const errorScreenMobile = require('../../../../images/icons/Error_Screen_Mobile.gif')

interface IErrorProps {
  errorCode: string
  errorMessage: string
}

export class ErrorPageTemplate extends React.PureComponent<IErrorProps> {
  public render() {
    return (
      <div className="container">
        <div className="tc-error-page">
          <div className="panel panel-default clearfix">
            <img className="tc-error-img hidden-xs" src={errorScreen} />
            <img className="tc-error-img-mob visible-xs" src={errorScreenMobile} />
            <h1 className="tc-error-code">{this.props.errorCode}</h1>
            <p className="tc-error-message">{this.props.errorMessage}</p>
            <div className="tc-error-button">
              <NavLink to="/">
                <Button className="error-redirect-to-dashboard" variant="super">
                  Go to dashboard
                </Button>
              </NavLink>
            </div>
            <div className="tc-error-report-link">
              <NavLink to="/app/support/error-report" className="tc-error-report-link-text">
                <Button variant="secondary" className="error-redirect-to-dashboard" size="medium">
                  Report an error
                </Button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
